import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { UsersMetaModel } from "common/models/page-models/users/users-form-model";
import { AddInternShipModel } from "common/models/page-models/Student Internship List/Add intership/add-internship-data-model";
import { AddInternshipFormDataService } from "common/services/data-services/admin/Intership-List/addInternnship-data.service";
import { AddInternshipMetaModel } from "common/models/page-models/Student Internship List/Add intership/add internship-form-meta-model";
import { CompanyGridDataService } from "common/services/data-services/admin/internship-company/company-grid-data.service";
import { CompanyLocationGridDataService } from "common/services/data-services/admin/internship-company/internship-company-location-grid-data.service";
import { CompanyMentorGridDataService } from "common/services/data-services/admin/internship-company/internship-company-mentor-grid-data.service";
import { InternshipStudentListDataService } from "common/services/data-services/admin/internship/internship-student-list.service";




@Injectable({
    providedIn: 'root'
})
export class AddInternshipFormWidgetService extends FormWidgetService<AddInternShipModel> {
    constructor(
        protected ds: AddInternshipFormDataService,
        private company: CompanyGridDataService,
        private companyLocation: CompanyLocationGridDataService,
        private companyMentor: CompanyMentorGridDataService,
        private internshipStudents: InternshipStudentListDataService
    ) {
        super(ds);
    }

    override prepareMetaModel(
        // dataModel: DataModel,
        dataModel: AddInternShipModel,
        metaModel: AddInternshipMetaModel,
        routeData: WidgetModel,event: any = null
      ): Promise<AddInternshipMetaModel> {
        return new Promise<AddInternshipMetaModel>((resolve, reject) => {
     
       if(routeData.transferData.pageType === "add"){
        metaModel.pageTitle = "Add Internship";
       } else if(routeData.transferData.pageType === "edit"){
        metaModel.pageTitle = "Edit Internship";
       }

    //    metaModel.properties['student_ids'].options = routeData.transferData.student_ids;
            this.company.postData('').then((data) =>{
                metaModel.properties['internshipCompanyId'].options = data.details;
                routeData.transferData.internshipCompany = data.details;
            })


            const startYear = 2022;
            const endYear = new Date().getFullYear();
            // const endYear = 2030;
            const yearOptions = [];
            for (let year = startYear; year <= endYear; year++) {
                yearOptions.push({
                value: `${year}`,
                name: year
                });
            }
            metaModel.properties['year'].options = yearOptions;

            // console.log("DATAMODEL", dataModel,metaModel,routeData,event);
            
            // if(dataModel.internshipCompanyId !== ""){
                // console.log(dataModel.internshipCompanyId,);
                
            // this.companyLocation.postData({internshipCompanyId: dataModel.internshipCompanyId}).then((data) => {
            //     metaModel.properties['internshipCompanyLocationId'].options = data.details;
            //     console.log(data.details.length);
            //     // console.log(dataModel);
            //     if(data.details.length === 1){
            //         dataModel.internshipCompanyLocationId = data?.details[0].id ? data.details[0].internshipCompanyId : 0;
            //         routeData.transferData.internshipCompanyLocation = data?.details[0]?.internshipCompanyId;
            //     }
                
            // })

            // this.companyMentor.postData({internshipCompanyId: dataModel.internshipCompanyId}).then((data) => {
            //     metaModel.properties['internshipCompanyMentorId'].options = data.details;
            //     console.log(data.details.length);
            //     // console.log(dataModel);
            //     if(data.details.length === 1){
            //         dataModel.internshipCompanyMentorId = data?.details[0].id ? data.details[0].id : 0;
            //         routeData.transferData.internshipCompanyMentor = data?.details[0]?.id;
            //     }
            // })

        // }

        // this.internshipStudents.postData({typeOfStatus: 2, year: "2024"}).then((data) =>{
        //     metaModel.properties['student_ids'].options = data.details;
        // })

            resolve(metaModel);
        });
      }

    getMetaModel(): MetaModel {
        const meta = new AddInternshipMetaModel();
        return meta.getMetaModel();
    }

    getAvailableStudents(payload){
        return new Promise((resolve, reject) => {
            this.internshipStudents.postData(payload).then((data) =>{
                resolve(data);
            }).catch(error =>{
                reject(error);
            })
        });
    }

    getInternshipCompanyLocationAndMentor(payload): Promise<{ locationData: any; mentorData: any }> {
        return Promise.all([
            this.companyLocation.postData(payload),
            this.companyMentor.postData(payload),
        ]).then(([locationData, mentorData]) => {
            // Log the results
            // console.log(locationData.details); // Locations
            // console.log(mentorData.details); // Mentors
            
            // Return the results in a structured format
            return {
                locationData: locationData.details,
                mentorData: mentorData.details,
            };
        }).catch((error) => {
            // Handle errors
            console.error('Error fetching location and mentor data:', error);
            throw error; // Rethrow to propagate the error to the caller
        });
    }
    

//    getInternshipCompanyMentor(payload){
//    this.companyMentor.postData(payload).then((data) => {
//                 // metaModel.properties['internshipCompanyMentorId'].options = data.details;
//                 console.log(data.details.length);
//                 // console.log(dataModel);
//                 // if(data.details.length === 1){
//                 //     dataModel.internshipCompanyMentorId = data?.details[0].id ? data.details[0].id : 0;
//                 //     routeData.transferData.internshipCompanyMentor = data?.details[0]?.id;
//                 // }
//             })
//    }    

   
}
